export default "__VITE_ASSET__Du6h1SaH__"